import styled from 'styled-components';
import { Button } from '@interstate/components/Button';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const StyledShareButton = styled(Button)`
    color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor || '#ffffff'} !important;
    font-weight: 600 !important;
    font-style: normal !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 4px !important;

    &:hover,
    &:focus,
    &:active {
        color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor || '#ffffff'} !important;
        background-color: transparent !important;
    }

    svg {
        width: 12px !important;
        height: 12px !important;
    }
`;

export const DropdownWrapper = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
`;

// One shared border/radius wraps the whole list; rows sit flush against each other
// (no per-row border, no gap) — only a row's own background flips on hover.
export const DropdownPanel = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: calc(100% + 4px);
    right: 7px;
    width: 350px;
    max-width: calc(100vw - 16px);
    background-color: ${({ theme }) => theme.uiBricks?.primaryBackground || '#ffffff'};
    border: 1px solid #b3b4b7;
    border-radius: 2px;
    z-index: 1300;
    overflow: hidden;

    @media (max-width: ${BreakPoints.TABLET}) {
        width: 247px;
    }
`;

export const DropdownItem = styled.button`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 6px 12px;
    background-color: ${({ theme }) => theme.uiBricks?.primaryBackground || '#ffffff'};
    border: none;
    text-align: left;
    font-family: inherit;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: ${({ theme }) => theme.uiBricks?.primaryAccentColor};
    cursor: pointer;
    /* Guards against label text wrapping/overflowing at the narrower phone width, where
       247px minus padding leaves less room than on tablet/desktop. */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    // Hover is guarded so disabled items keep their resting appearance:
    // :hover still matches a disabled button, it is only activation that is suppressed.
    &:not(:disabled):hover {
        background-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#1a2b6b'};
        color: ${({ theme }) => theme.uiBricks?.primaryButtonHoverTextColor || '#eef1f8'};
        outline: none;
    }

    // Setting color above overrides the browser's default greyed-out disabled
    // rendering, so the faded state has to be declared explicitly.
    &:disabled {
        background-color: ${({ theme }) => theme.uiBricks?.primaryBackground || '#ffffff'};
        color: ${({ theme }) => theme.uiBricks?.itemBoxUncheckedBorderColor || '#9b9b9b'};
        cursor: not-allowed;
    }
`;
